import { lazy, type ReactNode, Suspense } from 'react';
import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { Entry } from '@/app/entry';
import { NavShell } from '@/app/layout/nav-shell';
import { ServiceShell } from '@/app/layout/service-shell';
import { ChangePage } from '@/pages/change/change';
import { CouponPage } from '@/pages/coupon/coupon';
import type { RouteHandle } from '@/shared/lib/use-page-title';
import { Notice } from '@/shared/ui/notice/notice';

const Detail = lazy(() => import('@/pages/detail/detail').then((m) => ({ default: m.Detail })));
const Information = lazy(() => import('@/pages/information/information').then((m) => ({ default: m.Information })));

function withSuspense(node: ReactNode) {
  return (
    <Suspense
      fallback={
        <div className="route-fallback" role="status">
          로딩 중…
        </div>
      }
    >
      {node}
    </Suspense>
  );
}

export const routes: RouteObject[] = [
  {
    element: <ServiceShell />,
    children: [
      { index: true, element: <Entry />, handle: { title: '체인지콘' } satisfies RouteHandle },
      {
        path: '/coupon/change/:seqnumber',
        element: <ChangePage />,
        handle: { title: '쿠폰 교환' } satisfies RouteHandle,
      },
      { path: '/coupon/:seqnumber', element: <CouponPage />, handle: { title: '교환쿠폰' } satisfies RouteHandle },
      { path: '/detail', element: withSuspense(<Detail />), handle: { title: '상세보기' } satisfies RouteHandle },
      { path: '/error', element: <Notice />, handle: { title: '오류' } satisfies RouteHandle },
      {
        path: '/expired',
        element: <Notice message="페이지 접근 가능 기한이 만료되었습니다." />,
        handle: { title: '만료' } satisfies RouteHandle,
      },
      { path: '/:uri', element: <Entry />, handle: { title: '체인지콘' } satisfies RouteHandle },
    ],
  },
  {
    element: <NavShell />,
    children: [
      {
        path: '/information',
        element: withSuspense(<Information />),
        handle: { title: '이용안내' } satisfies RouteHandle,
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
